import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import {iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import CampusLogs from "./CampusLogs.jsx";

const AuditLogs = (props) => {
    let pageContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (paramVars.dType === "campus" && iAmHigherAuthority(99, dData?.role_weight)){
        pageContent = <CampusLogs id={paramVars?.eType} />;
    }
    else{
        pageContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return iAmHigherAuthority(99, dData?.role_weight) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default AuditLogs;